import { selectBalancingBuff } from "../balancingSelectors/selectBalancingBuffs";
var UtilImprovements = /** @class */ (function () {
    function UtilImprovements() {
        this.selectBuffFromImprovementType = function (improvementType, level) {
            if (level < 0 || level >= improvementType.level.length) {
                return 0;
            }
            // we are forced to cast `as any` since the type is generated from balancing.
            var currentLevel = improvementType.level[level];
            if (currentLevel.slotBonus != undefined) {
                return currentLevel.slotBonus;
            }
            else if (currentLevel.buffId) {
                var buff = selectBalancingBuff(currentLevel.buffId);
                return buff && buff.onTop ? buff.onTop : 0;
            }
            return 0;
        };
    }
    return UtilImprovements;
}());
export var utilImprovements = new UtilImprovements();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilImprovements.ts
// module id = 861
// module chunks = 3